import { STORAGE_KEY } from '@/constant/constant';
import { getLocal, getSession, setSession, removeSession } from '@/utils/storage';

/**
 * 判断是否在指定页面
 */
export const isInPage = (page: ReturnType<typeof window.CARTSEE_SUBSCRIBE.config.pages>): boolean => {
  if (window.CARTSEE_SUBSCRIBE?.config?.pages && typeof window.CARTSEE_SUBSCRIBE.config.pages === 'function') {
    return window.CARTSEE_SUBSCRIBE.config.pages() === page;
  }
  return false;
};

export const commonAddCart = (load) => {
  // 添加排除商品ID列表
  const excludedProductIds = JSON.parse(getLocal(STORAGE_KEY.EXCLUDE_PRODUCT_IDS) || '[]');

  if (getSession(STORAGE_KEY.ADD_CART_STATE) === '1') {
    if (window?.location?.pathname?.indexOf('/cart') === -1) {
      removeSession(STORAGE_KEY.ADD_CART_STATE);
    }
  }

  const addToCart = (detail: any = {}) => {
    const image = detail.data?.image;
    const productId = detail.data?.productId;
    const items = detail.data?.cartJson?.items;

    // 检查商品是否在排除列表中
    if (excludedProductIds.includes(productId)) {
      console.log('排除商品', productId);
      return;
    }

    // 加购图片获取优先级
    let imgSrc;
    if (image) {
      imgSrc = image;
    } else if (items.length > 0) {
      imgSrc = items[items.length - 1]?.image;
    }

    console.log('imgSrc', imgSrc);

    // 获取商品图片
    if (!imgSrc || imgSrc.length === 0) {
      console.warn('cart/add: image not found');
    } else {
      load(2, 'form/out/addPurchaseLoad', { name: 'zhuomai', res: { image: imgSrc } });
    }
  };

  const triggerAddToCartEvent = (e: any) => {
    if (e?.detail?.eventType === 'Cart/Add' && getSession(STORAGE_KEY.ADD_CART_STATE) !== '1') {
      setSession(STORAGE_KEY.ADD_CART_STATE, '1');
      addToCart(e?.detail);
    }
  };

  window.addEventListener('cartq/track', triggerAddToCartEvent);
};
